// Coach Studio API client (Gate-2). Same session-cookie + CSRF pattern as coachApi.
const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/coach/studio`;

function csrf() {
  const m = document.cookie.match(/(?:^|;\s*)csrf_token=([^;]+)/);
  return m ? decodeURIComponent(m[1]) : '';
}

async function call(path, method = 'GET', body) {
  const res = await fetch(`${BASE}${path}`, {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrf() },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    // FastAPI puts our structured error under data.detail; prefer its prose
    // `detail` field so users see a readable message, not raw JSON.
    const d = data.detail;
    const detail = (d && typeof d === 'object')
      ? (d.detail || d.error || `studio ${res.status}`)
      : (d || `studio ${res.status}`);
    throw new Error(detail);
  }
  return data;
}

export const studioApi = {
  saveRecording: (goal, steps) => call('/recordings', 'POST', { goal, steps }),
  revise: (walkthroughId) => call('/drafts/revise', 'POST', { walkthrough_id: walkthroughId }),
  generate: (goal, recordingId) => call('/drafts/generate', 'POST', { goal, recording_id: recordingId || null }),
  list: () => call('/drafts'),
  get: (id) => call(`/drafts/${id}`),
  edit: (id, patch) => call(`/drafts/${id}`, 'PUT', patch),
  validate: (id) => call(`/drafts/${id}/validate`, 'POST', {}),
  test: (id) => call(`/drafts/${id}/test`, 'POST', {}),
  submit: (id) => call(`/drafts/${id}/submit`, 'POST', {}),
  approve: (id) => call(`/drafts/${id}/approve`, 'POST', {}),
  reject: (id, reason) => call(`/drafts/${id}/reject`, 'POST', { reason }),
  publish: (id) => call(`/drafts/${id}/publish`, 'POST', {}),
};
